import { inject, injectable } from 'inversify'
import type IApiClient from "../IApiClient"
import type IPowerBIService from "./IPowerBIService"
import { SERVICES_TYPES } from '../ServicesTypes'
import type { IPowerBIReportInfo } from '@/models/PowerBI/IPowerBIReportInfo'

@injectable()
export class PowerBIService implements IPowerBIService {
    private readonly apiClient: IApiClient
    private readonly powerbiBaseUri: string = 'powerbi'

    constructor(@inject(SERVICES_TYPES.ApiClient) apiClient: IApiClient) {
        this.apiClient = apiClient
    }

    getPowerBIReportInfo(reportName: string, workgroupId: string): Promise<IPowerBIReportInfo> {
        return this.apiClient.get(`${this.powerbiBaseUri}/reportinfo?reportName=${reportName}&workgroupId=${workgroupId}`)
    }
}